import cx from "classnames";
import React, { ReactNode } from "react";

import { PolymorphicComponentProps } from "../../helpers";
import * as styles from "./Container.module.css";

interface IContainerProps {
  className?: string;
  children?: ReactNode;
}

type ContainerProps<E extends React.ElementType> = Readonly<IContainerProps> &
  PolymorphicComponentProps<E>;

export const Container = <E extends React.ElementType>(props: ContainerProps<E>): JSX.Element => {
  const { className, children, as: Component = "div", ...restProps } = props;

  return (
    <Component className={cx(styles.container, className)} {...restProps}>
      {children}
    </Component>
  );
};
